import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { getTenantTranslation } from '../utils/getTenantTranslation';

const ConfermaLiberaTavolo = ({ open, tavolo, onConferma, onAnnulla, loading = false }) => {
	const { t } = useTranslation();
	const tenantType = localStorage.getItem('tenantType');

	return (
		<Dialog open={open} onClose={onAnnulla}>
			<DialogTitle>
				{getTenantTranslation(t, tenantType, 'clearTableTitle')}
			</DialogTitle>
			<DialogContent>
				<Typography>
					{getTenantTranslation(t, tenantType, 'clearTableAlert')} <b>{tavolo}</b>?
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onAnnulla} color="secondary" variant="outlined" disabled={loading}>
					{t('cancel')}
				</Button>
				<Button onClick={onConferma} color="primary" variant="contained" disabled={loading}>
					{loading ? t('loading', { defaultValue: 'Loading...' }) : t('confirm')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfermaLiberaTavolo;
